import { canv } from '@/canv/global.js'

export class shapeDirectAccessStorage {

    constructor() {

    }

    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width * 3/4 - 2 * horizontalPadding;
        var allowedHeight = height - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width * 3/4 / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        var r = height / 30;
        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.ellipse(x + width * 7/8, y + height/2, width/8, height/2, 0, 0, 2 * Math.PI);
        canv.ctx.closePath();
        canv.ctx.moveTo(x + width * 7/8, y);
        canv.ctx.lineTo(x + width/16, y);
        canv.ctx.ellipse(x + width/16, y + height/2, width/16, height/2, 0, 3/2 * Math.PI, Math.PI/2, true);
        canv.ctx.lineTo(x + width * 7/8, y + height);
        canv.ctx.moveTo(x + width, y + height/2);
        canv.ctx.ellipse(x + width * 7/8, y + height/2, width/8, height/2, 0, 0, 2 * Math.PI);
    }

    getAvatar(color) {
        return `
        <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.2816 1.35472C13.5975 0.958146 67.9111 0.81106 70.1361 1.35472C84.0374 4.75138 85.1944 76.1389 70.1361 80.6743C67.9255 81.3401 13.4316 80.7993 12.2816 80.6743C-2.76054 79.0393 -2.76054 5.88806 12.2816 1.35472Z"
        fill="` + color + `"/>
        <path d="M70.1361 1.35472C67.9111 0.81106 13.5975 0.958146 12.2816 1.35472C-2.76053 5.88806 -2.76053 79.0393 12.2816 80.6743C13.4316 80.7993 67.9255 81.3401 70.1361 80.6743M70.1361 1.35472C84.0374 4.75138 85.1944 76.1389 70.1361 80.6743M70.1361 1.35472C58.5814 8.15072 58.5814 73.8727 70.1361 80.6743" stroke="black"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5255 1.11085C4.93671 0.986921 21.9097 0.940956 22.605 1.11085C26.9492 2.17231 27.3108 24.4809 22.605 25.8982C21.9142 26.1063 4.88489 25.9373 4.5255 25.8982C-0.175169 25.3873 -0.175169 2.52752 4.5255 1.11085Z" fill="` + fill + `"/>
                <path d="M22.605 1.11085C21.9097 0.940956 4.93671 0.986921 4.5255 1.11085C-0.175168 2.52752 -0.175168 25.3873 4.5255 25.8982C4.88489 25.9373 21.9142 26.1063 22.605 25.8982M22.605 1.11085C26.9492 2.17231 27.3108 24.4809 22.605 25.8982M22.605 1.11085C18.9942 3.2346 18.9942 23.7727 22.605 25.8982" stroke="black"/>
            </svg>
        `;
    }

}
